import React, { useState } from 'react';
import { Collapse, Stack } from '@mui/material';
import { ExpandSection } from './components/ExpandSection';
import type { SessionTimelineProps } from './types/sessionTimeline.types';

export function SessionTimeline({
  children,
  spacing = 2,
  collapsibleWhen = 3,
}: SessionTimelineProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const items = React.Children.toArray(children);
  const count = items.length;

  const useCollapse = collapsibleWhen > 0 && count >= collapsibleWhen;
  const shouldCollapse = useCollapse && !isExpanded;

  const hiddenCount = count - 2;
  const middleItems = count > 2 ? items.slice(1, -1) : [];

  if (!useCollapse) {
    return (
      <Stack spacing={spacing} sx={{ width: '100%' }}>
        {children}
      </Stack>
    );
  }

  return (
    <Stack spacing={spacing} sx={{ width: '100%' }}>
      {items[0]}
      {shouldCollapse && (
        <ExpandSection hiddenCount={hiddenCount} onExpand={() => setIsExpanded(true)} />
      )}
      <Collapse
        in={isExpanded}
        timeout={350}
        easing={{
          enter: 'cubic-bezier(0.4, 0, 0.2, 1)',
          exit: 'cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        <Stack spacing={spacing}>{middleItems}</Stack>
      </Collapse>
      {items[count - 1]}
    </Stack>
  );
}
